import { useGetAccountPaymentMethods } from '@cocoonspace/sdk-js/domains/account/account'

export const useGetDefaultPaymentMethod = ({
	enabled,
}: { enabled?: boolean } = {}) => {
	return useGetAccountPaymentMethods({
		query: {
			enabled,
			select: (res) =>
				res.data.find(
					({ default: isDefault, type }) => isDefault && type !== 'wallet',
				),
		},
	})
}
